import React from "react";
import "../../styles/Accordion.css"
import AllertIscrizione from "../multitessere/AllertIscrizione";
import Multitessere from "../../pages/Multitessere";
import TitoloSezioni from "../../commons/TitoloSezioni";
import Titolo from "../../commons/Titolo";
import AllertIscrizione6 from "../multitessere/AllertIscrizione6";
import AllertIscrizioneNoC from "../multitessere/AllertIscrizioneNoC";

function BRTablePrezzi() {
    return (
        <div className="d-flex flex-column m-auto"style={{maxWidth: "50em"}}>
                <div className="table-container">
                    <table className="table text-center m-auto" style={{maxWidth: "40em"}}>
                        <thead >
                        <tr >
                            <th scope="" style={{fontFamily: "Hammersmith One"}}></th>
                            <th scope="col" style={{width: "25%"}}>
                                3 mesi
                            </th>
                            <th scope="col" style={{width: "25%"}}>
                                6 mesi
                            </th>
                            <th scope="col" style={{width: "25%"}}>
                                Stagionale
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr style={{backgroundColor: "#F8F8F8"}}>
                            <th scope="row">Monosettimanale</th>
                            <td className={"data-cell"}>264€</td>
                            <td className={"data-cell"}>390€</td>
                            <td className={"data-cell"}>510€</td>
                        </tr>
                        <tr>
                            <th scope="row">Bisettimanale</th>
                            <td className={"data-cell"}>282€</td>
                            <td className={"data-cell"}>438€</td>
                            <td className={"data-cell"}>678€</td>
                        </tr>
                        </tbody>
                    </table>
                    <br/>
                </div>

            <AllertIscrizione6 />
            </div>
    );
}

export default BRTablePrezzi